//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './HL7MappingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type GetSingleHL7MappingQueryParameters = {
  id: number ;
}

export type PatchHL7MappingQueryParameters = {
  id: number ;
}

export type RemoveHL7MappingQueryParameters = {
  id: number ;
}

export type RestoreHL7MappingQueryParameters = {
  id: number ;
}

export function getFieldsUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFieldsDefaultOptions: Omit<UseQueryOptions<Types.MappingFieldDto[], unknown, Types.MappingFieldDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MappingFieldDto[], unknown, Types.MappingFieldDto[]>, 'queryFn'>> = {
};
export function getGetFieldsDefaultOptions() {
  return getFieldsDefaultOptions;
};
export function setGetFieldsDefaultOptions(options: typeof getFieldsDefaultOptions) {
  getFieldsDefaultOptions = options;
}

export function getFieldsQueryKey(): QueryKey;
export function getFieldsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'getFields',
    ]);
}
export function __getFields(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getFields(
axiosConfig    );
}

/**
 * Gets fields to which we can map to.
e.g. ['Patient.BirthDate', 'Patient.Name', 'Patient.CustomField.blablabla']
 */
export function useGetFieldsQuery<TSelectData = Types.MappingFieldDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFieldsQuery<TSelectData = Types.MappingFieldDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MappingFieldDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getFields(context, axiosConfig) : __getFields,
    queryKey: getFieldsQueryKey(),
    ...getFieldsDefaultOptions as unknown as Omit<UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets fields to which we can map to.
e.g. ['Patient.BirthDate', 'Patient.Name', 'Patient.CustomField.blablabla']
 */
export function setGetFieldsData(queryClient: QueryClient, updater: (data: Types.MappingFieldDto[] | undefined) => Types.MappingFieldDto[], ) {
  queryClient.setQueryData(getFieldsQueryKey(),
    updater
  );
}

/**
 * Gets fields to which we can map to.
e.g. ['Patient.BirthDate', 'Patient.Name', 'Patient.CustomField.blablabla']
 */
export function setGetFieldsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MappingFieldDto[] | undefined) => Types.MappingFieldDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function validateUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/validate-expression";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function validateMutationKey(): MutationKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'validate',
    ]);
}

/**
 * Validates passed expression
 */
export function useValidateMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, string, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, string, TContext> {
  const key = validateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (expression: string) => Client.validate(expression),
    mutationKey: key,
  });
}
  
export function getAllUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: Omit<UseQueryOptions<Types.HL7MappingListDto[], unknown, Types.HL7MappingListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7MappingListDto[], unknown, Types.HL7MappingListDto[]>, 'queryFn'>> = {
};
export function getGetAllDefaultOptions() {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: typeof getAllDefaultOptions) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'getAll',
    ]);
}
export function __getAll(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAll(
axiosConfig    );
}

/**
 * Gets all HL7 mappings.
 */
export function useGetAllQuery<TSelectData = Types.HL7MappingListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.HL7MappingListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.HL7MappingListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7MappingListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7MappingListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAll(context, axiosConfig) : __getAll,
    queryKey: getAllQueryKey(),
    ...getAllDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7MappingListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all HL7 mappings.
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.HL7MappingListDto[] | undefined) => Types.HL7MappingListDto[], ) {
  queryClient.setQueryData(getAllQueryKey(),
    updater
  );
}

/**
 * Gets all HL7 mappings.
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7MappingListDto[] | undefined) => Types.HL7MappingListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'create',
    ]);
}

/**
 * Creates a HL7 mapping.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.HL7MappingDto, unknown, Types.CreateHL7MappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.HL7MappingDto, unknown, Types.CreateHL7MappingDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateHL7MappingDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.HL7MappingDto, unknown, Types.HL7MappingDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7MappingDto, unknown, Types.HL7MappingDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleHL7MappingQueryParameters;

    return trimArrayEnd([
        'HL7MappingClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'HL7MappingClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.HL7MappingDto, TError = unknown>(dto: GetSingleHL7MappingQueryParameters, options?: Omit<UseQueryOptions<Types.HL7MappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets HL7 mapping by id.
 */
export function useGetSingleQuery<TSelectData = Types.HL7MappingDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.HL7MappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.HL7MappingDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7MappingDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleHL7MappingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7MappingDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7MappingDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets HL7 mapping by id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.HL7MappingDto | undefined) => Types.HL7MappingDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets HL7 mapping by id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7MappingDto | undefined) => Types.HL7MappingDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a hl7 mapping.
 * @param id The hl7 mapping id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchHL7MappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchHL7MappingDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchHL7MappingDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchHL7MappingQueryParameters & {
  dto: Types.PatchHL7MappingDto;
}

/**
 * Edits a hl7 mapping.
 * @param id The hl7 mapping id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchHL7MappingQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a HL7 mapping.
 * @param id The hl7 mapping id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveHL7MappingQueryParameters

/**
 * Removes a HL7 mapping.
 * @param id The hl7 mapping id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveHL7MappingQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function restoreUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/mappings/{id}/restore";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function restoreMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MappingClient',
      'restore',
      id as any,
    ]);
}

/**
 * Restores a HL7 mapping.
 * @param id The mapping id.
 */
export function useRestoreMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = restoreMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.restore(id),
    mutationKey: key,
  });
}
  
type Restore__MutationParameters = RestoreHL7MappingQueryParameters

/**
 * Restores a HL7 mapping.
 * @param id The mapping id.
 */
export function useRestoreMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Restore__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RestoreHL7MappingQueryParameters}): UseMutationResult<void, unknown, Restore__MutationParameters, TContext> {
  const key = restoreMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Restore__MutationParameters) => Client.restore(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}